module.exports = __webpack_public_path__ + "static/media/washbasin-dimensions.17f7d10c.svg";